import { createInstance, Resource } from 'i18next';
import { baseOptions } from './baseOptions';

// TODO: enable multiple namespaces instead of just a single packageName: https://jira.corp.tanium.com/browse/UX-2538
export const i18nFactory = (packageName: string, resources: Resource) => {
  const i18n = createInstance({
    ...baseOptions,
    ns: [packageName],
    defaultNS: packageName,
    resources,
  });

  i18n.init().catch((e) => {
    // eslint-disable-next-line no-console
    console.log(`Could not init i18n for ${packageName}.`, e);
  });

  return i18n;
};
